import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState } from 'react';

function useDisclosure(initialState, callbacks) {
  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      opened = _useState2[0],
      setOpened = _useState2[1];

  var open = function open() {
    var _a;

    if (!opened) {
      setOpened(true);
      (_a = callbacks == null ? void 0 : callbacks.onOpen) == null ? void 0 : _a.call(callbacks);
    }
  };

  var close = function close() {
    var _a;

    if (opened) {
      setOpened(false);
      (_a = callbacks == null ? void 0 : callbacks.onClose) == null ? void 0 : _a.call(callbacks);
    }
  };

  var toggle = function toggle() {
    opened ? close() : open();
  };

  return [opened, {
    open: open,
    close: close,
    toggle: toggle
  }];
}

export { useDisclosure };